import { isAgorotToShekelRatio } from "./agorot";

/**
 * Pick a display / valuation price for a share holding.
 *
 * Prefer live market data. If the bank persisted a current price that
 * disagrees with the market by more than 80% (stale quote / wrong match),
 * keep the bank price — except when the gap is ~100× (TASE שער in agorot
 * vs shekels). In that case use the shekel (market) price.
 * If neither exists, fall back to purchase price so unmatched Open Finance
 * rows are not silently worth ₪0.
 */
export function resolveShareStockPrice(
  marketPrice?: number | null,
  savedPrice?: number | null,
  purchasePrice?: number | null
): number {
  const market = Number(marketPrice) || 0;
  const saved = Number(savedPrice) || 0;
  const purchase = Number(purchasePrice) || 0;

  if (market > 0 && saved > 0) {
    const ratio = saved / market;
    if (isAgorotToShekelRatio(ratio)) return market;
    if (isAgorotToShekelRatio(1 / ratio)) return saved;
    const gap = Math.abs(saved - market) / Math.max(saved, market);
    return gap > 0.8 ? saved : market;
  }

  return market || saved || purchase;
}
